import { useState } from "react";
import Button from "../../components/common/button";
import useGetDepartmentsData from "../../hooks/use-get-department-data";
import CurrentStaff from "./current-staff";
import StaffModal from "./add-staff-modal";
import Spinner from "../../components/common/Spinner";
import { useGetUserPermission } from "../../context/AuthStaffUserContext";

const Staff: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { data, isLoading } = useGetDepartmentsData();
  const departmentsData = data?.result?.data?.departmentsData;

  const { write: isEditPermission } = useGetUserPermission("staff");

  if (isLoading) {
    return <Spinner fullScreenOverlay className="z-[100]" />;
  }
  if (!departmentsData) {
    return <div>Error while fetching departmentsData</div>;
  }

  return (
    <div className="p-6 min-h-full">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-[#111827]">Staff</h2>
        <Button
          disabled={!isEditPermission}
          variant="primary"
          className="whitespace-nowrap"
          onClick={openModal}
        >
          Add New
        </Button>
      </div>
      <div className="mt-6 bg-white p-6 rounded-xl border border-[#E5E7EB]">
        <h2 className="text-lg font-semibold text-[#111827] mb-4">Staff List</h2>
        <CurrentStaff departmentsData={departmentsData} />
      </div>

      {isModalOpen && (
        <StaffModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          departmentsData={departmentsData}
        />
      )}
    </div>
  );
};

export default Staff;
